export default "__VITE_ASSET__ChSzNWa5__"